import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/auth-store';
import { toast } from '@/shared/ui/use-toast';
import { notificationsApi } from '../api';
import type { NotificationsListResponse } from '../types';
import { notificationsQueryKey } from './queryKey';

export function useDismissNotification() {
  const qc = useQueryClient();
  const queryKey = notificationsQueryKey(useAuth().user?.id);
  return useMutation({
    mutationFn: (id: string) => notificationsApi.dismiss(id),
    onMutate: async (id) => {
      await qc.cancelQueries({ queryKey });
      const prev = qc.getQueryData<NotificationsListResponse>(queryKey);
      if (prev) {
        const removed = prev.items.find((n) => n.id === id);
        qc.setQueryData<NotificationsListResponse>(queryKey, {
          ...prev,
          items: prev.items.filter((n) => n.id !== id),
          unread_count:
            removed && !removed.is_read ? Math.max(0, prev.unread_count - 1) : prev.unread_count,
        });
      }
      return { prev };
    },
    onError: (_e, _id, ctx) => {
      if (ctx?.prev) qc.setQueryData(queryKey, ctx.prev);
      toast({ variant: 'destructive', description: 'Не удалось скрыть уведомление' });
    },
    onSettled: () => {
      void qc.invalidateQueries({ queryKey });
    },
  });
}
